import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, ImageBackground, StyleSheet, View } from 'react-native';

import { Theme } from '@constants';

import background from '../../assets/map/map_loading_background.png';
import pinPath from '../../assets/map/map_loading_pin.png';
import { TWCBackground } from '../primitives/TWCBackground/TWCBackground';
import { TWCText } from '../primitives/TWCText/TWCText';

const tPath = 'map.loading.';

// The Loading component shown when the map inventory is being fetched.
export const MapLoading = () => {
  const { t } = useTranslation();

  return (
    <View key={'mapLoading'} style={styles.tileBase}>
      <TWCBackground style={styles.backgroundGradient}>
        <ImageBackground
          accessibilityIgnoresInvertColors
          resizeMode={'cover'}
          source={background}
          style={styles.tileContent}
        >
          <Image accessibilityIgnoresInvertColors source={pinPath} style={styles.pin} />
          <TWCText noTestID variant={'mapLoadingText'}>
            {t(`${tPath}body`)}
          </TWCText>
        </ImageBackground>
      </TWCBackground>
    </View>
  );
};

const styles = StyleSheet.create({
  backgroundGradient: {
    flex: 1,
  },
  pin: {
    height: Theme.px(150),
    marginBottom: Theme.px(41),
    width: Theme.px(108),
  },
  tileBase: {
    flex: 1,
    overflow: 'hidden',
  },
  tileContent: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
});
